import { InputMask } from 'primereact/inputmask';

const BaseInputMask = (props)=>{
    return <InputMask {...props}></InputMask>
}

export default BaseInputMask;